$(function () {

	$('.js-contact-map').each(function () {
		let map = $('#ymap');
		let coordinates = JSON.parse(JSON.stringify(map.data('coordinates')));
		let icon = map.data('icon');


		ymaps.ready(init);
		function init() {
			// Создаем карту.
			let myMap = new ymaps.Map("ymap",
				{
					center: [coordinates.lat, coordinates.lng],
					zoom: 15,
					yandexMapDisablePoiInteractivity: true,
					suppressObsoleteBrowserNotifier:true,
					suppressMapOpenBlock: true,
					controls: ['zoomControl']
				},
				{
					searchControlProvider: 'yandex#search'
				}),

				myPlacemark = new ymaps.Placemark(myMap.getCenter(), {
					hintContent: '',
					balloonContent: ''
				}, {
					iconLayout: 'default#image',
					iconImageHref: icon,
					iconImageSize: [50, 66],
					iconImageOffset: [-25 , -33]
				})
			myMap.geoObjects
				.add(myPlacemark);

			myMap.panes.get('ground').getElement().style.filter = 'grayscale(100%)';
			myMap.behaviors.disable('scrollZoom');

		}
	});


	let mapMultipoint = $('#map');
	let urlJSON = mapMultipoint.data('url');

	if (mapMultipoint.length) {
		ymaps.ready(init);

		function init() {
			var myMap = new ymaps.Map('map', {
					center: [55.76, 37.64],
					zoom: 10,
					controls: ['zoomControl']
				}, {
					searchControlProvider: 'yandex#search'
				}),
				objectManager = new ymaps.ObjectManager({
					// Чтобы метки начали кластеризоваться, выставляем опцию.
					clusterize: true,
					// clusterIcons: [
					//     {
					//         href: 'images/cluster.png',
					//         size: [60, 60],
					//         offset: [-30, -30]
					//     }
					// ],
					// ObjectManager принимает те же опции, что и кластеризатор.
					clusterDisableClickZoom: false,
					clusterHasHint: false,
					clusterhasBalloon: false,
					gridSize: 60,
					zoomMargin: [125,125],
				});

			// Чтобы задать опции одиночным объектам и кластерам,
			// обратимся к дочерним коллекциям ObjectManager.
			// objectManager.clusters.options.set('iconLayout', 'default#image', 'clusterIcons', '../imagеs/cluster.png');
			myMap.geoObjects.add(objectManager);

			myMap.panes.get('ground').getElement().style.filter = 'grayscale(100%)';
			myMap.behaviors.disable('scrollZoom');

			$.ajax({
				url: urlJSON
			}).done(function (data) {
				objectManager.add(data.items);

				$.each( data.europe_items, function( key, itemData ) {
					var placemark = new ymaps.Placemark(itemData.coordinates, {}, itemData.options);
					myMap.geoObjects.add(placemark)
				});

				setTimeout(function () {
					myMap.setBounds(objectManager.getBounds(), {
						checkZoomRange: true
					});
				}, 300);
			});

			$('.shop__form form').on('change', function (e) {
				e.preventDefault();
				var form = $(this);

				$.ajax({
					url: form.attr('action'),
					method: form.attr('method'),
					data: form.serialize()
				}).done(function (data) {

					var select2Options = {
						dropdownAutoWidth: true,
						containerCssClass: 'select',
						dropdownCssClass: 'no-input'
					};

					var newCitiesOptions = '<option value="">Выберите город</option>';
					if (data.cities.length) {
						for (var cityId in data.cities) {
							newCitiesOptions += '<option value="' + data.cities[cityId] + '">' + data.cities[cityId] + '</option>';
						}
					}

					var citySelect = form.find('.js-select[name="city"]');

					var cityVal = citySelect.val();

					citySelect.select2('destroy').html(newCitiesOptions).prop("disabled", false)
						.select2(select2Options);

					if (citySelect.find('option[value="' + cityVal + '"]').length != 0) {
						citySelect.val(cityVal);
						citySelect.trigger('change.select2');
					}

					var newNetworkOptions = '<option value="">Выберите сеть</option>';
					if (data.networks.length) {
						for (var networkId in data.networks) {
							newNetworkOptions += '<option value="' + data.networks[networkId] + '">' + data.networks[networkId] + '</option>';
						}
					}

					var networkSelect = form.find('.js-select[name="network"]');

					var networkVal = networkSelect.val();

					networkSelect.select2('destroy').html(newNetworkOptions).prop("disabled", false)
						.select2(select2Options);

					if (networkSelect.find('option[value="' + networkVal + '"]').length != 0) {
						networkSelect.val(networkVal);
						networkSelect.trigger('change.select2');
					}

					objectManager.removeAll();
					objectManager.add(data.items);

					setTimeout(function () {
						myMap.setBounds(objectManager.getBounds(), {
							checkZoomRange: true
						});
					}, 300);
				});
			});
		}

	}

});


